import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { BaseService } from './base.service';
import { AuthenticationService } from './authentication.service';
import firebase from 'firebase/compat/app';
import 'firebase/compat/messaging';
import { environment } from 'src/environments/environment';
// import { CommunicationService } from '../../services/communication.service';

let self;
@Injectable()
export class MessagingService {
    currentMessage = new Subject();
    setTokenValue = new Subject();
    changeColorOfBell = new Subject();
    private messaging: firebase.messaging.Messaging | null = null;
    private swRegistration: ServiceWorkerRegistration | null = null;
    constructor(
        public baseService: BaseService,
        private authservice: AuthenticationService,
        // private communication: CommunicationService
    ) {

    }

    isSupported() {
        return firebase.messaging.isSupported();
    }

    async initializeMessaging(swRegistration?: ServiceWorkerRegistration) {
        try{
            const supported = typeof window !== 'undefined' && await firebase.messaging.isSupported();
            if (supported) {
                const firebaseApp = firebase.apps.length ? firebase.app() : firebase.initializeApp(environment.firebase);
                this.messaging = firebaseApp.messaging();
                if (swRegistration) {
                    this.swRegistration = swRegistration;
                }
            }
        }catch(e){
            console.warn("Firebase not supported",e)
        }
        
    }

    async requestPermission(userId: string) {
        if (!this.messaging) return;

        try {
            const token = await this.messaging.getToken({
                ...(this.swRegistration ? { serviceWorkerRegistration: this.swRegistration } : {})
            });
            console.log('FCM Token:', token);
            this.setnotificationtoDb(userId, token);
            this.receiveMessage();
        } catch (error) {
            console.error('Error getting notification permission:', error);
        }
    }

    getPayload(): Observable<any> {
        return this.currentMessage.asObservable();
    }

    receiveMessage() {
        if (!this.messaging) return;

        this.messaging.onMessage((payload) => {
            console.log('Message received:', payload);
            this.currentMessage.next(payload);
            // this.communication.setTokenValue(payload);
        });
    }

    setnotificationtoDb(userId: any, token: any, setID: boolean = true) {
        const json = {
            user_id: userId,
            fcm_token_id: token,
            userAgent: navigator.userAgent,
            voip_token_id: "",
            fcm_type: "FCM",
            // count: "count"
        };
        
        this.baseService.action(json, 'add', 'notification', 'notification_account').subscribe(
            (data) => {
                if (setID && data.resource?.[0]?.id) {
                    localStorage.setItem("notificationId", data.resource[0].id);
                }
            },
            (err) => {
                console.error("Error saving token to DB:", err);
            }
        );
    }

    sendNotification(destinationUserId: any, action: string, role: string, consultID: any, message: any): Observable<any> {
        const hasPayload = { 
            webAction: action, 
            extras: "", 
            androidAction: "", 
            title: "Video Call Request", 
            message: message, 
            senderId: this.authservice.getCurrentUser()['user_id'], 
            channelId: consultID, 
            senderName: this.authservice.getCurrentUser()['first_name'] 
        };
        
        const json = {
            destination_user_id: destinationUserId,
            src_user_id: this.authservice.getCurrentUser()['user_id'],
            payload: JSON.stringify(hasPayload),
            readUnreadStatus: false,
            role: role,
            action: action
        };
        
        return this.baseService.action(json, 'add', 'notification', 'push_notification');
    }

    setcolorData(data: any) {
        this.changeColorOfBell.next(data);
    }

    colorOfBell(): Observable<any> {
        return this.changeColorOfBell.asObservable();
    }

    setNotificationPayload(payload: any) {
        this.setTokenValue.next(payload);
    }

    getNotificationPayload$(): Observable<any> {
        return this.setTokenValue.asObservable();
    }

    getNotification$(page_no?: any): Observable<any> {
        const obj = {
            page_size: 10,
            args: "noCount:1",
            ...(page_no >= 1 && { page_no: page_no })
        };
        
        return this.baseService.getData(obj, "", "push_notification", "notification", "GET_MY_ALL_NOTIFICATION");
    }

    getNotificationCount$(): Observable<any> {
        return this.baseService.get("GET_MY_ALL_NOTIFICATION_COUNT", "noCount:1", "push_notification", "notification");
    }
}
